import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  positionCache = new Map()

  beforeStream(event) {
    const streamElement = event.target
    const { render } = event.detail
    const action = streamElement.getAttribute("action")

    // Capture position on remove (FLIP: First)
    if (action === "remove") {
      const removedId = streamElement.getAttribute("target")
      const removedTask = document.getElementById(removedId)

      if (removedTask) {
        const rect = removedTask.getBoundingClientRect()
        this.positionCache.set(removedId, {
          top: rect.top,
          left: rect.left
        })
      }
    }

    // Wrap render callback for insert actions
    if (["prepend", "append", "after", "before"].includes(action)) {
      const originalRender = render

      event.detail.render = (streamElement) => {
        // Get task ID from template before rendering
        const template = streamElement.querySelector("template")
        const taskFrame = template?.content.querySelector(".task-item")
        const taskId = taskFrame?.id
        const firstPosition = taskId ? this.positionCache.get(taskId) : null

        // Call original render - task gets inserted into DOM
        originalRender(streamElement)

        // Animate if we have a cached position (FLIP: Last, Invert, Play)
        if (firstPosition && taskId) {
          requestAnimationFrame(() => {
            const insertedTask = document.getElementById(taskId)
            if (!insertedTask) return

            // Animate the inner content div, not the turbo-frame
            const contentDiv = insertedTask.querySelector(".task-content")
            if (!contentDiv) return

            // FLIP: Last - measure new position
            const lastRect = contentDiv.getBoundingClientRect()

            // FLIP: Invert - calculate delta
            const deltaX = firstPosition.left - lastRect.left
            const deltaY = firstPosition.top - lastRect.top

            // FLIP: Play - animate from old to new position
            contentDiv.animate(
              [
                {
                  transform: `translate(${deltaX}px, ${deltaY}px)`,
                  opacity: 0.5,
                  backgroundColor: "#fef08a"
                },
                {
                  transform: "translate(0, 0)",
                  opacity: 1,
                  backgroundColor: "transparent"
                }
              ],
              {
                duration: 400,
                easing: "cubic-bezier(0.33, 1, 0.68, 1)"
              }
            )

            // Cleanup
            this.positionCache.delete(taskId)
          })
        }
      }
    }
  }

  focusFirstTask(event) {
    const activeElement = document.activeElement
    if (activeElement?.closest('.task-item')) return

    event.preventDefault()
    const firstTask = document.querySelector('.task-item input[type="text"]')
    if (firstTask) {
      firstTask.focus()
      firstTask.setSelectionRange(firstTask.value.length, firstTask.value.length)
    }
  }

  focusLastTask(event) {
    const activeElement = document.activeElement
    if (activeElement?.closest('.task-item')) return

    event.preventDefault()
    const allInputs = Array.from(document.querySelectorAll('.task-item input[type="text"]'))
    const lastTask = allInputs[allInputs.length - 1]
    if (lastTask) {
      lastTask.focus()
      lastTask.setSelectionRange(lastTask.value.length, lastTask.value.length)
    }
  }
}
